<div class="pdf-export">
  <section class="guia3-report">
    <app-reportes-title [pageData]="pageData()"></app-reportes-title>

    <app-report-controls
      [guideId]="'guia-iii'"
      [hasData]="hasData()"
      [isExporting]="isExporting"
      (scenariosChange)="scenarios = $event"
      (hasAppliedFiltersChange)="hasAppliedFilters = $event"
      (analysisModeChange)="analysisMode = $event"
      (activeFacetsChange)="activeFacets = $event"
      (activeFiltersChange)="activeFilters = $event"
      (exportPdf)="exportToPdf()">
    </app-report-controls>

  @if (respondedCountSignal() > 0) {
    <div class="report-content">
      @if (!hasAppliedFilters) {
        <app-reporte-preview></app-reporte-preview>
        <app-reporte-detalle [detailContent]="detailContent() ?? null"></app-reporte-detalle>
      } @else {
        <app-report-scenario
          [guideId]="'guia-iii'"
          [campaignId]="campaignId()"
          [scenarios]="scenarios"
          (removeScenario)="removeScenario($event)">
        </app-report-scenario>
      }
    </div>
  } @else {
    <app-empty-state></app-empty-state>
  }
</section>
</div>
